import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";

import { ApiKey, NewApiKey } from "./api-key.models";

interface GetApiKeysResponse {
  apiKeys: ApiKey[];
}

@Injectable()
export class ApiKeyService {
  private http = inject(HttpClient);

  getApiKeys(): Observable<ApiKey[]> {
    return this.http
      .get<GetApiKeysResponse>("apikeys")
      .pipe(map(response => response.apiKeys));
  }

  createApiKey(): Observable<NewApiKey> {
    return this.http.post<NewApiKey>("apikeys", {});
  }

  toggleApiKey(id: string, isEnabled: boolean): Observable<boolean> {
    return this.http
      .post<{ isEnabled: boolean }>(`apikeys/${id}/toggle`, { isEnabled })
      .pipe(map(response => response.isEnabled));
  }

  deleteApiKey(id: string): Observable<void> {
    return this.http.delete<void>(`apikeys/${id}`);
  }
}
